/*
 * KLUBS — CTA Tally (logique de conversion homogène)
 * ---------------------------------------------------
 * Tous les CTA publics "Ouvrir ma boutique" passent par cette logique.
 *
 * Décision (cf. spec growth) :
 *   1. URL Tally remplie  → ouvre Tally (popup si le widget est chargé, sinon nouvel onglet)
 *   2. Trigger popup dispo → privilégier le popup plutôt qu'un simple lien
 *   3. Pas de popup dispo  → ouvrir l'URL Tally dans un nouvel onglet (href + target=_blank)
 *   4. URL Tally vide      → fallback /pages/ouvrir-ma-boutique#ouvrir-boutique
 *                            (le handler global de theme.liquid ouvre alors le popup jaZVk1)
 *
 * Aucun identifiant de formulaire n'est codé en dur ici :
 *   - le cas "URL vide" réutilise le handler global #ouvrir-boutique (form id dans theme.liquid)
 *   - le cas "URL remplie" déduit l'id du formulaire depuis l'URL éditable du Customizer
 */
(function () {
  'use strict';
  if (window.__klubsCtaInit) return;
  window.__klubsCtaInit = true;

  // Extrait l'identifiant de formulaire Tally depuis une URL éditable.
  // https://tally.so/r/jaZVk1  → jaZVk1
  // https://tally.so/embed/jaZVk1?... → jaZVk1
  function tallyFormId(url) {
    if (!url) return '';
    try {
      var clean = url.replace(/[#?].*$/, '');
      var parts = clean.split('/').filter(Boolean);
      return parts.length ? parts[parts.length - 1] : '';
    } catch (e) {
      return '';
    }
  }

  function openTallyPopup(id) {
    if (!id || typeof window.Tally === 'undefined') return false;
    window.Tally.openPopup(id, {
      layout: 'modal',
      width: 750,
      overlay: true,
      emoji: { text: '👋', animation: 'wave' },
      hideTitle: true,
      autoClose: 5000,
      hiddenFields: window.klubsTallyHidden ? window.klubsTallyHidden() : {}
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-klubs-tally-cta]');
    if (!el) return;

    var url = el.getAttribute('data-tally-url') || '';

    // Cas URL vide : on laisse le handler global #ouvrir-boutique faire son travail.
    if (!url) return;

    var id = tallyFormId(url);

    // Trigger popup disponible → on ouvre le popup (expérience homogène) et on bloque la nav.
    if (id && openTallyPopup(id)) {
      e.preventDefault();
      return;
    }

    // Tally pas encore chargé (il l'est à la demande, voir layout/theme.liquid) : on le charge puis on
    // ouvre le popup ; s'il ne répond pas en 4 s, le formulaire s'ouvre dans un nouvel onglet.
    if (id && typeof window.Tally === 'undefined' && typeof window.klubsLoadTally === 'function') {
      e.preventDefault();
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        window.open(url, '_blank', 'noopener');
      }, 4000);
      window.klubsLoadTally(function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        if (!openTallyPopup(id)) window.open(url, '_blank', 'noopener');
      });
      return;
    }

    // Sans le chargeur (ancienne mise en page) : un essai court, sinon nouvel onglet.
    if (id && typeof window.Tally === 'undefined') {
      e.preventDefault();
      setTimeout(function () {
        if (!openTallyPopup(id)) {
          window.open(url, '_blank', 'noopener');
        }
      }, 400);
    }
    // Sinon : pas d'id exploitable → comportement natif du lien (target=_blank).
  });
})();
